import { createStore } from "vuex";
import axios from "axios";

const store = createStore({
    state: {
        // logged in user id
        user_id: 0,

        // raw data
        artworks: [],

        // category data
        categories: [],

        // pagination
        pagination: {},

        // login page
        login_page: "",

		// artwork edit page
		artwork_edit_page: "",

        // http headers
        headers: {
            "Content-Type": "application/json",
        },

		// gallery refresh pending (state changed, reviews updated - gallery view needs updating)
		galleryRefreshPending: false,

        // public gallery config
        publicGalleryConfig: null,
    },

    actions: {
        /**
         * Initialise the public gallery from the data attributes
         * @param {*} param0
         * @param {*} config
         */
        initPublicGalleryConfig({ commit }, config) {
            commit("setPublicGalleryConfig", config);
        },

        /**
         * Get Artworks Data
         * @param {*} params
         */
        getArtworks({ commit, dispatch, state, rootState }, params) {
            let requestURL = window.ff_settings.rest_url + "ravenswood/v1/artworks";

            // override search params with public gallery config if defined
            var cfg = state.publicGalleryConfig;
            if (cfg) {
				params.reviewState = 'public';
                params.publicWinners = cfg.showWinners;
                params.publicFinalists = cfg.showFinalists;
                params.publicDateFrom = cfg.dateFrom;
                params.publicDateTo = cfg.dateTo;
                params.publicCurrentUser = cfg.showCurrentUser;
            }

            return axios({
                method: "get",
                url: requestURL,
                params: params,
                headers: state.headers,
            })
                .then((response) => {
                    commit("setArtworks", response.data.data);
                    commit("setPagination", response.data.pagination);
                    return response.data;
                })
                .catch((error) => {
                    console.error(error);
                    return Promise.reject(error);
                });
        },

        /**
         * Get single artwork
         */
        getArtwork({ commit, dispatch, state, rootState }, params) {
            let requestURL = window.ff_settings.rest_url + "ravenswood/v1/artwork/" + params.id;

            return axios({
                method: "get",
                url: requestURL,
                headers: state.headers,
            })
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    console.error(error);
                    return Promise.reject(error);
                });
        },

        /**
         * Get Categories Data
         * @param {*} params
         */
        getCategories({ commit, dispatch, state, rootState }, params) {
            let requestURL = window.ff_settings.rest_url + "ravenswood/v1/artwork-categories";

            return axios({
                method: "get",
                url: requestURL,
                params: params,
                headers: state.headers,
            })
                .then((response) => {
                    commit("setCategories", response.data.data);
                    return response.data;
                })
                .catch((error) => {
                    console.error(error);
                    return Promise.reject(error);
                });
        },

        /**
         * Get Categories Data
         * @param {*} params
         */
        updateReview({ commit, dispatch, state, rootState }, params) {
            let requestURL = window.ff_settings.rest_url + "ravenswood/v1/update-review";

            return axios({
                method: "post",
                url: requestURL,
                params: params,
                headers: state.headers,
            })
                .then((response) => {
                    return response.data;
                })
                .catch((error) => {
                    console.error(error);
                    return Promise.reject(error);
                });
        },

        /**
         *
         */
    },

    mutations: {
        setPublicGalleryConfig(state, config) {
            // console.log("Public Gallery Config", config);
            state.publicGalleryConfig = config;
        },

        // set the raw data from the spreadsheet in a useful format
        setArtworks(state, payload) {
            // for each item in the payload, check if the review has been submitted with a matching user ID
            for (const artwork of payload) {
                if (artwork.reviews && typeof artwork.reviews == "array") {
                    for (const review of artwork.reviews) {
                        if (review.author == state.user_id) {
                            artwork.reviewed_me = review.reviewed.toLowerCase() == "yes";
                            artwork.shortlist_me = review.shortlist.toLowerCase() == "yes";
                            artwork.finalist_me = review.finalist.toLowerCase() == "yes";
                        } else {
                            artwork.reviewed_other = review.reviewed.toLowerCase() == "yes";
                            artwork.shortlist_other = review.shortlist.toLowerCase() == "yes";
                            artwork.finalist_other = review.finalist.toLowerCase() == "yes";
                        }
                    }
                }
            }

            state.artworks = payload;
        },

        // set array of categories
        setCategories(state, payload) {
            state.categories = payload;
        },

        setPagination(state, payload) {
            state.pagination = payload;
        },

        setUserId(state, payload) {
            state.user_id = payload;
            state.headers["X-WP-User"] = payload;
        },

        setNonce(state, payload) {
            state.headers["X-WP-Nonce"] = payload;
        },

        setLoginPage(state, payload) {
            state.login_page = payload;
        },

        setArtworkEditPage(state, payload) {
            state.artwork_edit_page = payload;
        },

		setRefreshPending(state, payload) {
			state.galleryRefreshPending = payload;
		}
    },

    getters: {
        getPublicGalleryConfig(state) {
            return state.publicGalleryConfig;
        },

        getArtworks(state) {
            return state.artworks;
        },

        getCategories(state) {
            return state.categories;
        },

        getPagination(state) {
            return state.pagination;
        },

        getUserId(state) {
            return state.user_id;
        },

        getLoginPage(state) {
            return state.login_page;
        },

		getArtworkEditPage(state) {
			return state.artwork_edit_page;
		},

        // get my review from an artwork
        getMyReview: (state) => (artwork) => {
            let review = artwork.reviews.filter((review) => {
                return review.author == state.user_id;
            });

            if (review.length > 0) {
                return review[0];
            }

            return null;
        },

		getRefreshPending(state) {
			return state.galleryRefreshPending
		}
    },
});

export default store;
